import SearchLandingPage from '@/components/modules/Landing/SearchLandingPage';
import { searchLandingPages } from '@/content/searchLandingPages';

const EducationSolutionPage = () => <SearchLandingPage config={searchLandingPages.education} />;

export default EducationSolutionPage;
